import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { getConsent, setConsent } from "@/lib/analytics";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsent()) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const choose = (value) => {
    setConsent(value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-consent"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-md z-[60] bg-[var(--ink)] text-white shadow-2xl"
        >
          <div className="p-6 md:p-7">
            <div className="flex items-center gap-3 mb-3">
              <Cookie className="w-5 h-5 text-[var(--oxblood-light)]" strokeWidth={1.6} />
              <p className="text-xs uppercase tracking-[0.3em] text-white/60">Your privacy</p>
            </div>
            <p className="text-sm leading-relaxed text-white/80">
              We use essential cookies to run this site and, with your consent, Google Analytics to
              understand how it's used. Read our{" "}
              <Link to="/cookies" data-testid="consent-cookies-link" className="text-white underline underline-offset-2 hover:text-[var(--oxblood-light)] transition-colors">
                Cookie Policy
              </Link>.
            </p>
            <div className="mt-5 flex flex-col sm:flex-row gap-3">
              <button
                data-testid="cookie-accept-btn"
                onClick={() => choose("accepted")}
                className="flex-1 bg-[var(--oxblood)] text-white px-6 py-3 text-sm tracking-wide rounded-full hover:bg-[var(--oxblood-hover)] transition-colors"
              >
                Accept analytics
              </button>
              <button
                data-testid="cookie-decline-btn"
                onClick={() => choose("declined")}
                className="flex-1 border border-white/30 text-white px-6 py-3 text-sm tracking-wide rounded-full hover:bg-white/10 transition-colors"
              >
                Decline
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
